import type { ChatWidgetSettings } from '@/models/replicas'

export interface ChatWidgetColors {
  primaryColor: string
  backgroundColor: string
  textColor: string
}

export const defaultColors: ChatWidgetColors = {
  primaryColor: '#000000',
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
} as const

export const getColorsFromSettings = (chatWidgetSettings: ChatWidgetSettings | null) => {
  return {
    primaryColor: chatWidgetSettings?.primary_color ?? defaultColors.primaryColor,
    backgroundColor: chatWidgetSettings?.background_color ?? defaultColors.backgroundColor,
    textColor: chatWidgetSettings?.text_color ?? defaultColors.textColor,
  }
}
